module.exports = {
  title: 'License',
  author: 'Enzo Manuel Mangano',
  date: '2024-12-07',
  slug: 'privacy',
  tags: ['docs', 'license'],
};
